import register from '../util/init';
import {impoliteScrollTo} from '../util/scrolling';
import {windowSize} from '../util/miscellaneous';

let horizontalCount = 2.25;
let currentlyScrolling;
let enableScrollSnap = !window.Modernizr.touch;
let winWidth = windowSize().width;

let scrollLeft = 0;
let scrollDistance = 0;
let closestSnap = 0;

const scrollThis = document.querySelector('.featured-stories .scroll-this');
let scrollContentWidth = winWidth * horizontalCount;

function scrollSnap (val) {
  // TODO detect about 25% of scroll then do ceil/floor
  // scrollDistance = scrollLeft - closestSnap;
  // if (Math.abs(scrollDistance) < winWidth * 0.2) {
  //   // hasn't scrolled more that 20% od screen so just reset
  //   closestSnap = Math.round(val / winWidth) * winWidth;
  // } else {
  //   // scrolled more than 20% of screen floor/ceil it
  //   if (scrollDistance > 0) {
  //     // right
  //     closestSnap = Math.ceil(val / winWidth) * winWidth;
  //   } else {
  //     // left
  //     closestSnap = Math.floor(val / winWidth) * winWidth;
  //   }
  // }

  // scrolling to 50% window width
  closestSnap = Math.round(val / (winWidth * 0.75)) * (winWidth * 0.75);

  detectLeftRightState(closestSnap);
  // Timeout - allow the right/left animation to end
  window.setTimeout(() => {
    impoliteScrollTo(scrollThis, closestSnap, 400, 'left', 0, () => {
      window.clearTimeout(currentlyScrolling);
    });
  }, 320);
}

function detectLeftRightState (left) {
  // left
  if (left > 0) {
    document.querySelector('.featured-stories').classList.add('allow-left');
  } else {
    document.querySelector('.featured-stories').classList.remove('allow-left');
  }
  // right
  if (left + winWidth < scrollContentWidth) {
    document.querySelector('.featured-stories').classList.add('allow-right');
  } else {
    document.querySelector('.featured-stories').classList.remove('allow-right');
  }
}

function homeInit (container) {
  // bind click action next/prev (touch disabled in css)
  document.querySelectorAll('.featured-stories .next-left, .featured-stories .next-right').forEach((control) => {
    control.addEventListener('click', (e) => {
      e.preventDefault();
      const movement = control.classList.contains('next-right') ? (winWidth * 0.75) : -(winWidth * 0.75);
      scrollSnap(movement + closestSnap);
    });
  });
  // resize event
  scrollThis.addEventListener('resize', (e) => {
    // reset sizes
    winWidth = windowSize().width;
    scrollContentWidth = winWidth * horizontalCount;
  });
  // scroll event
  // scrollThis.addEventListener('scroll', (e) => {
  //   if (enableScrollSnap) {
  //     scrollLeft = scrollThis.scrollLeft;
  //     window.clearTimeout(currentlyScrolling);
  //     // debounce
  //     currentlyScrolling = window.setTimeout(() => {
  //       scrollSnap(scrollLeft);
  //     }, 500);
  //   }
  // });
}

register('home', homeInit);



// WEBPACK FOOTER //
// ./assets/j/src/home.js